<div class="messages-div">
  <div class="messages-title-div">Developer Messages<button class="clear" (click)="messageService.clear()">clear</button></div>
  <div *ngFor='let message of messageService.messages'> {{message}}</div>
</div>
